module.exports = __webpack_public_path__ + "static/media/11-image15.1d08ba39.jpg";